<ng-container [appPreloader]="[endpoints.USER_INVITE_POST]"
  [preloaderType]="preloaderTypes.OVERLAY">
</ng-container>

<div mat-dialog-title>
  <div class="align-v-top">
    <i class="icon-letter is-big ic-white mr-15"></i>
    <div class="title-container">
      <div class="dialog-caption mb-10">It pays to share</div>
      <span class="fs-big">
        Invite your friends to join TaxTank, and for each friend who subscribes we'll give you a month's free subscription.
        We'll also reward your friends with 50% off their first 3 months.
      </span>
    </div>
  </div>

  <button mat-dialog-close class="btn icon-close"></button>
</div>

<div mat-dialog-content>
  <div class="mv-20">
    <div class="align-v-center mb-15">
      <img src="assets/img/icons/friend-invite.png" class="icon">
      <div class="w-100 ml-20">
        <span class="fs-small">Enter your friend's details below</span>

        <form class="transparent" [formGroup]="form" (ngSubmit)="submit()" appFormErrorScroll>
          <div class="row">
            <div class="col-12 col-lg-6">
              <mat-form-field>
                <mat-label>Full Name</mat-label>
                <input matInput formControlName="firstName" placeholder="Enter first name" required>
                @if (form.get('firstName').invalid) {
                  <mat-error>
                    <app-validation-error [errors]="form.get('firstName').errors"></app-validation-error>
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-12 col-lg-6">
              <mat-form-field>
                <mat-label>Email</mat-label>
                <input type="email" matInput formControlName="email" placeholder="name@friend.com" required>
                <i matPrefix class="icon-at"></i>
                @if (form.get('email').invalid) {
                  <mat-error>
                    <app-validation-error [errors]="form.get('email').errors"></app-validation-error>
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <div class="w-100 text-right">
            <button class="btn primary" type="submit">Invite</button>
          </div>
        </form>

        <!-- @Todo TT-2095 replace with real invite-link -->
        <app-copy-to-clipboard copyContent="test" label="Or simply share link below"></app-copy-to-clipboard>
      </div>
    </div>
  </div>
</div>
